const merchantRregistrationType = [
  {
    value: '个人独资企业',
    key: '个人独资企业'
  },
  {
    value: '个体工商户',
    key: '个体工商户'
  },
  {
    value: '其他有限责任公司',
    key: '其他有限责任公司'
  },
  {
    value: '有限合伙企业',
    key: '有限合伙企业'
  },
  {
    value: '有限责任公司',
    key: '有限责任公司'
  },
  {
    value: '有限责任公司（法人独资）',
    key: '有限责任公司（法人独资）'
  },
  {
    value: '有限责任公司（港澳台法人独资）',
    key: '有限责任公司（港澳台法人独资）'
  },
  {
    value: '有限责任公司（自然人投资或控股的法人独资）',
    key: '有限责任公司（自然人投资或控股的法人独资）'
  },
  {
    value: '有限责任公司（自然人投资或控股）',
    key: '有限责任公司（自然人投资或控股）'
  },
  {
    value: '有限责任公司（自然人独资）',
    key: '有限责任公司（自然人独资）'
  },
  {
    value: '有限责任公司（非自然人投资或控股的法人独资）',
    key: '有限责任公司（非自然人投资或控股的法人独资）'
  },
  {
    value: '法人商事主体【有限责任公司（自然人投资或控股）】',
    key: '法人商事主体【有限责任公司（自然人投资或控股）】'
  },
  {
    value: '法人商事主体【有限责任公司（自然人独资）】',
    key: '法人商事主体【有限责任公司（自然人独资）】'
  },
  {
    value: '非法人商事主体【普通个体户】',
    key: '非法人商事主体【普通个体户】'
  },
  {
    value: '01',
    key: '持牌法团（FI）'
  }
]

export default merchantRregistrationType
